<template>
    <component
        v-if="!loading"
        :bpi="bpi"
        :bpiOutPut="bpiOutPut"
        :is="bpiVersion"
        class="bg-gray-200 font-output"
    />
</template>

<script>
// import store from "@/store";
import Detailed from "@/views/output/detailed";
import Simplified from "@/views/output/simplified";
export default {
    components: {
        Detailed,
        Simplified
    },
    data() {
        return { bpiVersion: "", loading: true, bpi: {}, bpiOutPut: {} };
    },
    created() {
        this.bpi = this.$store.state.user.bpi;
        this.bpiOutPut = this.$store.state.user.bpiOutPut;
        if (this.bpiOutPut !== null) {
            if (this.bpi.bpiVersion !== "Version Simplifiée") {
                this.bpiVersion = "detailed";
                this.loading = false;
            } else {
                this.bpiVersion = "simplified";
                this.loading = false;
            }
        } else {
            this.$store.watch(
                state => {
                    return state.user; // could also put a Getter here
                },
                () => {
                    //something changed do something
                    this.init();
                },
                //Optional Deep if you need it
                {
                    deep: true
                }
            );
        }
    },

    methods: {
        init() {
            if (this.bpi.bpiVersion !== "Version Simplifiée") {
                this.bpiVersion = "detailed";
            } else {
                this.bpiVersion = "simplified";
            }
        }
    },
    watch: {
        bpi: function(newValue) {
            if (newValue !== undefined) this.loading = false;
        }
    },
    // beforeRouteEnter(to, from, next) {
    //   if (to.query.uid !== undefined) {
    //     const promise1 = store.dispatch(
    //       "user/selectBpiOutPutFromParams1",
    //       to.query.uid
    //     );
    //     const promise2 = store.dispatch(
    //       "user/selectBpiOutPutFromParams2",
    //       to.query.uid
    //     );
    //     Promise.all([promise1, promise2]);
    //     next();
    //   }
    // },
    computed: {}
};
</script>
